
export function getExtension(url) {
    if (typeof url !== 'string') {
        throw new Error('`url` argument must be a string');
    }

    const baseUrl = url.split('?')[0];
    const baseName = baseUrl.split('\\').pop().split('/').pop();
    return baseName.indexOf('.') > -1 ? baseName.substring(baseName.lastIndexOf('.') + 1) : '';
}

export function isHlsSource(media) {
    return /\.m3u8/i.test(media.src) || ['application/x-mpegURL', 'application/vnd.apple.mpegurl'].indexOf(media.type) > -1;
}

export function isDashSource(media) {
    return /\.mpd/i.test(media.src) || media.type === 'application/dash+xml';
}

export function predictType(url) {
    const extension = getExtension(url);
    let type;

    // If no extension found, check if media is a vendor iframe
    if (!extension) {
        return 'video/mp4';
    }

    // Check native media types
    switch (extension) {
        case 'm3u8':
            type = 'application/x-mpegURL';
            break;
        case 'mpd':
            type = 'application/dash+xml';
            break;
        case 'webm':
            type = 'video/webm';
            break;
        default:
            type = 'video/mp4';
            break;
    }
    return type;
}

export function isAutoplaySupported(media, autoplay, muted, callback) {
    const playPromise = media.play();
    if (playPromise !== undefined) {
        playPromise.then(() => {
            // Umuted autoplay works.
            media.pause();
            autoplay(true);
            muted(false);
            return callback();
        }).catch(() => {
            // Unmuted autoplay failed. New attempt with muted autoplay.
            media.volume = 0;
            media.muted = true;
            media.play().then(() => {
                // Muted autoplay works.
                media.pause();
                autoplay(true);
                muted(true);
                return callback();
            }).catch(() => {
                // Both muted and unmuted autoplay failed. Fallback to click to play.
                media.volume = 1;
                media.muted = false;
                autoplay(false);
                muted(false);
                callback();
            });
        });
    } else {
        autoplay(!media.paused || 'Promise' in window && playPromise instanceof Promise);
        media.pause();
        muted(false);
        callback();
    }
}